var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mobileDesktop',{attrs:{"min_price":_vm.min_price,"max_price":_vm.max_price,"get_filter":_vm.get_filter,"category":_vm.category,"object_type":_vm.object_type,"sales":_vm.sales},on:{"change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }